export const getBillingDocumentCellStyles = () => ({
  BillingDocumentCell: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  BillingDocumentNumberGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  MismatchInformation: {
    marginLeft: 5,
    color: '#424242',
    fontSize: 14,
  },
});
